import React from 'react';
import {
  HiOutlineMail,
  HiOutlineCalendar,
  HiOutlineDocumentDownload,
} from 'react-icons/hi';

export default function InvestorFloatingButtons() {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      
      {/* Contact Founder */}
      <a
        href="mailto:founder@million2trillion.com"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-purple-600 hover:bg-purple-700 text-white p-3 rounded-full shadow-lg"
        title="Contact Founder"
      >
        <HiOutlineMail size={24} />
      </a>

      {/* Schedule Intro Call */}
      <a
        href="https://cal.com/mr-senthee/intro"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-gray-800 hover:bg-gray-700 text-white p-3 rounded-full shadow-lg"
        title="Schedule Call"
      >
        <HiOutlineCalendar size={24} />
      </a>

      {/* Get Investor Deck */}
      <a
        href="/docs/investor-deck.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-white text-black hover:bg-gray-100 p-3 rounded-full shadow-lg"
        title="Download Investor Deck"
      >
        <HiOutlineDocumentDownload size={24} />
      </a>
    </div>
  );
}
